import type { LabelHTMLAttributes } from 'react';
import './Label.css';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /** Renders a required-field marker. The marker is text ("required"), not a
   * bare colour/asterisk-only signal — a11y.md §2 (never colour-only). */
  required?: boolean;
}

/** Semantic `<label>`, styled via tokens only. Always pair with a real form
 * control's `id`/`htmlFor` — this component does not infer one. */
export function Label({ required = false, children, className, ...rest }: LabelProps) {
  return (
    <label className={['dpr-label', className].filter(Boolean).join(' ')} {...rest}>
      {children}
      {required ? <span className="dpr-label__required"> (required)</span> : null}
    </label>
  );
}
